import { render, staticRenderFns } from "./inventoryList.vue?vue&type=template&id=dd6839cc&scoped=true&"
import script from "./inventoryList.vue?vue&type=script&lang=js&"
export * from "./inventoryList.vue?vue&type=script&lang=js&"
import style0 from "./inventoryList.vue?vue&type=style&index=0&id=dd6839cc&scoped=true&lang=css&"
import style1 from "./inventoryList.vue?vue&type=style&index=1&id=dd6839cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6839cc",
  null
  
)

export default component.exports